import { Workout } from '@kinomap-dev/ng-ui-lib';
export class WorkoutState {
  workouts: Workout[] = [];
  isLoadingWorkouts: boolean = false;
  areWorkoutsComplete: boolean = false;
}
